import { jsx as _jsx } from "react/jsx-runtime";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { Link } from '../Link';
export function Markdown({ className, parseRawHTML, openLinksInNewTab, children, }) {
    const options = {
        children,
        className,
        rehypePlugins: [],
        components: {
            // ref is removed due to type issues, but we don't need it
            a: ({ node, children, ref, ...props }) => (_jsx(Link, { ...props, target: openLinksInNewTab ? '_blank' : undefined, children: children })),
        },
    };
    if (parseRawHTML) {
        options.rehypePlugins?.push(rehypeRaw);
    }
    return _jsx(ReactMarkdown, { ...options });
}
